const timezones = {
    'Africa/Abidjan': 0,
    'Africa/Accra': 0,
    'Africa/Addis_Ababa': 3,
    'Africa/Algiers': 1,
    'Africa/Asmara': 3,
    'Africa/Bamako': 0,
    'Africa/Bangui': 1,
    'Africa/Banjul': 0,
    'Africa/Bissau': 0,
    'Africa/Blantyre': 2,
    'Africa/Brazzaville': 1,
    'Africa/Bujumbura': 2,
    'Africa/Cairo': 2,
    'Africa/Casablanca': 1,
    'Africa/Ceuta': 1,
    'Africa/Conakry': 0,
    'Africa/Dakar': 0,
    'Africa/Dar_es_Salaam': 3,
    'Africa/Djibouti': 3,
    'Africa/Douala': 1,
    'Africa/El_Aaiun': 0,
    'Africa/Freetown': 0,
    'Africa/Gaborone': 2,
    'Africa/Harare': 2,
    'Africa/Johannesburg': 2,
    'Africa/Juba': 3,
    'Africa/Kampala': 3,
    'Africa/Khartoum': 2,
    'Africa/Kigali': 2,
    'Africa/Kinshasa': 1,
    'Africa/Lagos': 1,
    'Africa/Libreville': 1,
    'Africa/Lome': 0,
    'Africa/Luanda': 1,
    'Africa/Lubumbashi': 2,
    'Africa/Lusaka': 2,
    'Africa/Malabo': 1,
    'Africa/Maputo': 2,
    'Africa/Maseru': 2,
    'Africa/Mbabane': 2,
    'Africa/Mogadishu': 3,
    'Africa/Monrovia': 0,
    'Africa/Nairobi': 3,
    'Africa/Ndjamena': 1,
    'Africa/Niamey': 1,
    'Africa/Nouakchott': 0,
    'Africa/Ouagadougou': 0,
    'Africa/PortoNovo': 1,
    'Africa/Sao_Tome': 0,
    'Africa/Timbuktu': 0,
    'Africa/Tripoli': 2,
    'Africa/Tunis': 1,
    'Africa/Windhoek': 2,
    'America/Adak': -10,
    'America/Anchorage': -9,
    'America/Anguilla': -4,
    'America/Antigua': -4,
    'America/Araguaina': -3,
    'America/Argentina/Buenos_Aires': -3,
    'America/Argentina/Catamarca': -3,
    'America/Argentina/ComodRivadavia': -3,
    'America/Argentina/Cordoba': -3,
    'America/Argentina/Jujuy': -3,
    'America/Argentina/La_Rioja': -3,
    'America/Argentina/Mendoza': -3,
    'America/Argentina/Rio_Gallegos': -3,
    'America/Argentina/Salta': -3,
    'America/Argentina/San_Juan': -3,
    'America/Argentina/San_Luis': -3,
    'America/Argentina/Tucuman': -3,
    'America/Argentina/Ushuaia': -3,
    'America/Aruba': -4,
    'America/Asuncion': -4,
    'America/Atikokan': -5,
    'America/Atka': -10,
    'America/Bahia': -3,
    'America/Bahia_Banderas': -6,
    'America/Barbados': -4,
    'America/Belem': -3,
    'America/Belize': -6,
    'America/BlancSablon': -4,
    'America/Boa_Vista': -4,
    'America/Bogota': -5,
    'America/Boise': -7,
    'America/Buenos_Aires': -3,
    'America/Cambridge_Bay': -7,
    'America/Campo_Grande': -4,
    'America/Cancun': -5,
    'America/Caracas': -4,
    'America/Catamarca': -3,
    'America/Cayenne': -3,
    'America/Cayman': -5,
    'America/Chicago': -6,
    'America/Chihuahua': -7,
    'America/Coral_Harbour': -5,
    'America/Cordoba': -3,
    'America/Costa_Rica': -6,
    'America/Creston': -7,
    'America/Cuiaba': -4,
    'America/Curacao': -4,
    'America/Danmarkshavn': 0,
    'America/Dawson': -8,
    'America/Dawson_Creek': -7,
    'America/Denver': -7,
    'America/Detroit': -5,
    'America/Dominica': -4,
    'America/Edmonton': -7,
    'America/Eirunepe': -5,
    'America/El_Salvador': -6,
    'America/Ensenada': -8,
    'America/Fort_Nelson': -7,
    'America/Fort_Wayne': -5,
    'America/Fortaleza': -3,
    'America/Glace_Bay': -4,
    'America/Godthab': -3,
    'America/Goose_Bay': -4,
    'America/Grand_Turk': -4,
    'America/Grenada': -4,
    'America/Guadeloupe': -4,
    'America/Guatemala': -6,
    'America/Guayaquil': -5,
    'America/Guyana': -4,
    'America/Halifax': -4,
    'America/Havana': -5,
    'America/Hermosillo': -7,
    'America/Indiana/Indianapolis': -5,
    'America/Indiana/Knox': -6,
    'America/Indiana/Marengo': -5,
    'America/Indiana/Petersburg': -5,
    'America/Indiana/Tell_City': -6,
    'America/Indiana/Vevay': -5,
    'America/Indiana/Vincennes': -5,
    'America/Indiana/Winamac': -5,
    'America/Indianapolis': -5,
    'America/Inuvik': -7,
    'America/Iqaluit': -5,
    'America/Jamaica': -5,
    'America/Jujuy': -3,
    'America/Juneau': -9,
    'America/Kentucky/Louisville': -5,
    'America/Kentucky/Monticello': -5,
    'America/Knox_IN': -6,
    'America/Kralendijk': -4,
    'America/La_Paz': -4,
    'America/Lima': -5,
    'America/Los_Angeles': -8,
    'America/Louisville': -5,
    'America/Lower_Princes': -4,
    'America/Maceio': -3,
    'America/Managua': -6,
    'America/Manaus': -4,
    'America/Marigot': -4,
    'America/Martinique': -4,
    'America/Matamoros': -6,
    'America/Mazatlan': -7,
    'America/Mendoza': -3,
    'America/Menominee': -6,
    'America/Merida': -6,
    'America/Metlakatla': -9,
    'America/Mexico_City': -6,
    'America/Miquelon': -3,
    'America/Moncton': -4,
    'America/Monterrey': -6,
    'America/Montevideo': -3,
    'America/Montreal': -5,
    'America/Montserrat': -4,
    'America/Nassau': -5,
    'America/New_York': -5,
    'America/Nipigon': -5,
    'America/Nome': -9,
    'America/Noronha': -2,
    'America/North_Dakota/Beulah': -6,
    'America/North_Dakota/Center': -6,
    'America/North_Dakota/New_Salem': -6,
    'America/Ojinaga': -7,
    'America/Panama': -5,
    'America/Pangnirtung': -5,
    'America/Paramaribo': -3,
    'America/Phoenix': -7,
    'America/Port_of_Spain': -4,
    'America/PortauPrince': -5,
    'America/Porto_Acre': -5,
    'America/Porto_Velho': -4,
    'America/Puerto_Rico': -4,
    'America/Punta_Arenas': -3,
    'America/Rainy_River': -6,
    'America/Rankin_Inlet': -6,
    'America/Recife': -3,
    'America/Regina': -6,
    'America/Resolute': -6,
    'America/Rio_Branco': -5,
    'America/Rosario': -3,
    'America/Santa_Isabel': -8,
    'America/Santarem': -3,
    'America/Santiago': -4,
    'America/Santo_Domingo': -4,
    'America/Sao_Paulo': -3,
    'America/Scoresbysund': -1,
    'America/Shiprock': -7,
    'America/Sitka': -9,
    'America/St_Barthelemy': -4,
    'America/St_Johns': -3,
    'America/St_Kitts': -4,
    'America/St_Lucia': -4,
    'America/St_Thomas': -4,
    'America/St_Vincent': -4,
    'America/Swift_Current': -6,
    'America/Tegucigalpa': -6,
    'America/Thule': -4,
    'America/Thunder_Bay': -5,
    'America/Tijuana': -8,
    'America/Toronto': -5,
    'America/Tortola': -4,
    'America/Vancouver': -8,
    'America/Virgin': -4,
    'America/Whitehorse': -8,
    'America/Winnipeg': -6,
    'America/Yakutat': -9,
    'America/Yellowknife': -7,
    'Antarctica/Casey': 11,
    'Antarctica/Davis': 7,
    'Antarctica/DumontDUrville': 10,
    'Antarctica/Macquarie': 11,
    'Antarctica/Mawson': 5,
    'Antarctica/McMurdo': 12,
    'Antarctica/Palmer': -3,
    'Antarctica/Rothera': -3,
    'Antarctica/South_Pole': 12,
    'Antarctica/Syowa': 3,
    'Antarctica/Troll': 0,
    'Antarctica/Vostok': 6,
    'Arctic/Longyearbyen': 1,
    'Asia/Aden': 3,
    'Asia/Almaty': 6,
    'Asia/Amman': 2,
    'Asia/Anadyr': 12,
    'Asia/Aqtau': 5,
    'Asia/Aqtobe': 5,
    'Asia/Ashgabat': 5,
    'Asia/Ashkhabad': 5,
    'Asia/Atyrau': 5,
    'Asia/Baghdad': 3,
    'Asia/Bahrain': 3,
    'Asia/Baku': 4,
    'Asia/Bangkok': 7,
    'Asia/Barnaul': 7,
    'Asia/Beirut': 2,
    'Asia/Bishkek': 6,
    'Asia/Brunei': 8,
    'Asia/Calcutta': 5,
    'Asia/Chita': 9,
    'Asia/Choibalsan': 8,
    'Asia/Chongqing': 8,
    'Asia/Chungking': 8,
    'Asia/Colombo': 5,
    'Asia/Dacca': 6,
    'Asia/Damascus': 2,
    'Asia/Dhaka': 6,
    'Asia/Dili': 9,
    'Asia/Dubai': 4,
    'Asia/Dushanbe': 5,
    'Asia/Famagusta': 2,
    'Asia/Gaza': 2,
    'Asia/Harbin': 8,
    'Asia/Hebron': 2,
    'Asia/Ho_Chi_Minh': 7,
    'Asia/Hong_Kong': 8,
    'Asia/Hovd': 7,
    'Asia/Irkutsk': 8,
    'Asia/Istanbul': 3,
    'Asia/Jakarta': 7,
    'Asia/Jayapura': 9,
    'Asia/Jerusalem': 2,
    'Asia/Kabul': 4,
    'Asia/Kamchatka': 12,
    'Asia/Karachi': 5,
    'Asia/Kashgar': 6,
    'Asia/Kathmandu': 5,
    'Asia/Katmandu': 5,
    'Asia/Khandyga': 9,
    'Asia/Kolkata': 5,
    'Asia/Krasnoyarsk': 7,
    'Asia/Kuala_Lumpur': 8,
    'Asia/Kuching': 8,
    'Asia/Kuwait': 3,
    'Asia/Macao': 8,
    'Asia/Macau': 8,
    'Asia/Magadan': 11,
    'Asia/Makassar': 8,
    'Asia/Manila': 8,
    'Asia/Muscat': 4,
    'Asia/Novokuznetsk': 7,
    'Asia/Novosibirsk': 7,
    'Asia/Omsk': 6,
    'Asia/Oral': 5,
    'Asia/Phnom_Penh': 7,
    'Asia/Pontianak': 7,
    'Asia/Pyongyang': 9,
    'Asia/Qatar': 3,
    'Asia/Qyzylorda': 5,
    'Asia/Rangoon': 6,
    'Asia/Riyadh': 3,
    'Asia/Saigon': 7,
    'Asia/Sakhalin': 11,
    'Asia/Samarkand': 5,
    'Asia/Seoul': 9,
    'Asia/Shanghai': 8,
    'Asia/Singapore': 8,
    'Asia/Srednekolymsk': 11,
    'Asia/Taipei': 8,
    'Asia/Tashkent': 5,
    'Asia/Tbilisi': 4,
    'Asia/Tehran': 3,
    'Asia/Tel_Aviv': 2,
    'Asia/Thimbu': 6,
    'Asia/Thimphu': 6,
    'Asia/Tokyo': 9,
    'Asia/Tomsk': 7,
    'Asia/Ujung_Pandang': 8,
    'Asia/Ulaanbaatar': 8,
    'Asia/Ulan_Bator': 8,
    'Asia/Urumqi': 6,
    'Asia/UstNera': 10,
    'Asia/Vientiane': 7,
    'Asia/Vladivostok': 10,
    'Asia/Yakutsk': 9,
    'Asia/Yangon': 6,
    'Asia/Yekaterinburg': 5,
    'Asia/Yerevan': 4,
    'Atlantic/Azores': -1,
    'Atlantic/Bermuda': -4,
    'Atlantic/Canary': 0,
    'Atlantic/Cape_Verde': -1,
    'Atlantic/Faeroe': 0,
    'Atlantic/Faroe': 0,
    'Atlantic/Jan_Mayen': 1,
    'Atlantic/Madeira': 0,
    'Atlantic/Reykjavik': 0,
    'Atlantic/South_Georgia': -2,
    'Atlantic/St_Helena': 0,
    'Atlantic/Stanley': -3,
    'Australia/ACT': 10,
    'Australia/Adelaide': 9,
    'Australia/Brisbane': 10,
    'Australia/Broken_Hill': 9,
    'Australia/Canberra': 10,
    'Australia/Currie': 10,
    'Australia/Darwin': 9,
    'Australia/Eucla': 8,
    'Australia/Hobart': 10,
    'Australia/LHI': 10,
    'Australia/Lindeman': 10,
    'Australia/Lord_Howe': 10,
    'Australia/Melbourne': 10,
    'Australia/North': 9,
    'Australia/NSW': 10,
    'Australia/Perth': 8,
    'Australia/Queensland': 10,
    'Australia/South': 9,
    'Australia/Sydney': 10,
    'Australia/Tasmania': 10,
    'Australia/Victoria': 10,
    'Australia/West': 8,
    'Australia/Yancowinna': 9,
    'Brazil/Acre': -5,
    'Brazil/DeNoronha': -2,
    'Brazil/East': -3,
    'Brazil/West': -4,
    'Canada/Atlantic': -4,
    'Canada/Central': -6,
    'Canada/Eastern': -5,
    'Canada/Mountain': -7,
    'Canada/Newfoundland': -3,
    'Canada/Pacific': -8,
    'Canada/Saskatchewan': -6,
    'Canada/Yukon': -8,
    CET: 1,
    'Chile/Continental': -4,
    'Chile/EasterIsland': -6,
    CST6CDT: -6,
    Cuba: -5,
    EET: 2,
    Egypt: 2,
    Eire: 0,
    EST: -5,
    EST5EDT: -5,
    'Etc/GMT': 0,
    'Etc/GMT+0': 0,
    'Etc/GMT+1': -1,
    'Etc/GMT+10': -10,
    'Etc/GMT+11': -11,
    'Etc/GMT+12': -12,
    'Etc/GMT+2': -2,
    'Etc/GMT+3': -3,
    'Etc/GMT+4': -4,
    'Etc/GMT+5': -5,
    'Etc/GMT+6': -6,
    'Etc/GMT+7': -7,
    'Etc/GMT+8': -8,
    'Etc/GMT+9': -9,
    'Etc/GMT0': 0,
    'Etc/GMT1': 1,
    'Etc/GMT10': 10,
    'Etc/GMT11': 11,
    'Etc/GMT12': 12,
    'Etc/GMT13': 13,
    'Etc/GMT14': 14,
    'Etc/GMT2': 2,
    'Etc/GMT3': 3,
    'Etc/GMT4': 4,
    'Etc/GMT5': 5,
    'Etc/GMT6': 6,
    'Etc/GMT7': 7,
    'Etc/GMT8': 8,
    'Etc/GMT9': 9,
    'Etc/Greenwich': 0,
    'Etc/UCT': 0,
    'Etc/Universal': 0,
    'Etc/UTC': 0,
    'Etc/Zulu': 0,
    'Europe/Amsterdam': 1,
    'Europe/Andorra': 1,
    'Europe/Astrakhan': 4,
    'Europe/Athens': 2,
    'Europe/Belfast': 0,
    'Europe/Belgrade': 1,
    'Europe/Berlin': 1,
    'Europe/Bratislava': 1,
    'Europe/Brussels': 1,
    'Europe/Bucharest': 2,
    'Europe/Budapest': 1,
    'Europe/Busingen': 1,
    'Europe/Chisinau': 2,
    'Europe/Copenhagen': 1,
    'Europe/Dublin': 0,
    'Europe/Gibraltar': 1,
    'Europe/Guernsey': 0,
    'Europe/Helsinki': 2,
    'Europe/Isle_of_Man': 0,
    'Europe/Istanbul': 3,
    'Europe/Jersey': 0,
    'Europe/Kaliningrad': 2,
    'Europe/Kiev': 2,
    'Europe/Kirov': 3,
    'Europe/Lisbon': 0,
    'Europe/Ljubljana': 1,
    'Europe/London': 0,
    'Europe/Luxembourg': 1,
    'Europe/Madrid': 1,
    'Europe/Malta': 1,
    'Europe/Mariehamn': 2,
    'Europe/Minsk': 3,
    'Europe/Monaco': 1,
    'Europe/Moscow': 3,
    'Europe/Nicosia': 2,
    'Europe/Oslo': 1,
    'Europe/Paris': 1,
    'Europe/Podgorica': 1,
    'Europe/Prague': 1,
    'Europe/Riga': 2,
    'Europe/Rome': 1,
    'Europe/Samara': 4,
    'Europe/San_Marino': 1,
    'Europe/Sarajevo': 1,
    'Europe/Saratov': 4,
    'Europe/Simferopol': 3,
    'Europe/Skopje': 1,
    'Europe/Sofia': 2,
    'Europe/Stockholm': 1,
    'Europe/Tallinn': 2,
    'Europe/Tirane': 1,
    'Europe/Tiraspol': 2,
    'Europe/Ulyanovsk': 4,
    'Europe/Uzhgorod': 2,
    'Europe/Vaduz': 1,
    'Europe/Vatican': 1,
    'Europe/Vienna': 1,
    'Europe/Vilnius': 2,
    'Europe/Volgograd': 4,
    'Europe/Warsaw': 1,
    'Europe/Zagreb': 1,
    'Europe/Zaporozhye': 2,
    'Europe/Zurich': 1,
    GB: 0,
    GBEire: 0,
    GMT: 0,
    'GMT+0': 0,
    GMT0: 0,
    Greenwich: 0,
    Hongkong: 8,
    HST: -10,
    Iceland: 0,
    'Indian/Antananarivo': 3,
    'Indian/Chagos': 6,
    'Indian/Christmas': 7,
    'Indian/Cocos': 6,
    'Indian/Comoro': 3,
    'Indian/Kerguelen': 5,
    'Indian/Mahe': 4,
    'Indian/Maldives': 5,
    'Indian/Mauritius': 4,
    'Indian/Mayotte': 3,
    'Indian/Reunion': 4,
    Iran: 3,
    Israel: 2,
    Jamaica: -5,
    Japan: 9,
    Kwajalein: 12,
    Libya: 2,
    MET: 1,
    'Mexico/BajaNorte': -8,
    'Mexico/BajaSur': -7,
    'Mexico/General': -6,
    MST: -7,
    MST7MDT: -7,
    Navajo: -7,
    NZ: 12,
    NZCHAT: 12,
    'Pacific/Apia': 13,
    'Pacific/Auckland': 12,
    'Pacific/Bougainville': 11,
    'Pacific/Chatham': 12,
    'Pacific/Chuuk': 10,
    'Pacific/Easter': -6,
    'Pacific/Efate': 11,
    'Pacific/Enderbury': 13,
    'Pacific/Fakaofo': 13,
    'Pacific/Fiji': 12,
    'Pacific/Funafuti': 12,
    'Pacific/Galapagos': -6,
    'Pacific/Gambier': -9,
    'Pacific/Guadalcanal': 11,
    'Pacific/Guam': 10,
    'Pacific/Honolulu': -10,
    'Pacific/Johnston': -10,
    'Pacific/Kiritimati': 14,
    'Pacific/Kosrae': 11,
    'Pacific/Kwajalein': 12,
    'Pacific/Majuro': 12,
    'Pacific/Marquesas': -9,
    'Pacific/Midway': -11,
    'Pacific/Nauru': 12,
    'Pacific/Niue': -11,
    'Pacific/Norfolk': 11,
    'Pacific/Noumea': 11,
    'Pacific/Pago_Pago': -11,
    'Pacific/Palau': 9,
    'Pacific/Pitcairn': -8,
    'Pacific/Pohnpei': 11,
    'Pacific/Ponape': 11,
    'Pacific/Port_Moresby': 10,
    'Pacific/Rarotonga': -10,
    'Pacific/Saipan': 10,
    'Pacific/Samoa': -11,
    'Pacific/Tahiti': -10,
    'Pacific/Tarawa': 12,
    'Pacific/Tongatapu': 13,
    'Pacific/Truk': 10,
    'Pacific/Wake': 12,
    'Pacific/Wallis': 12,
    'Pacific/Yap': 10,
    Poland: 1,
    Portugal: 0,
    PRC: 8,
    PST8PDT: -8,
    ROC: 8,
    ROK: 9,
    Singapore: 8,
    Turkey: 3,
    UCT: 0,
    Universal: 0,
    'US/Alaska': -9,
    'US/Aleutian': -10,
    'US/Arizona': -7,
    'US/Central': -6,
    'US/Eastern': -5,
    'US/EastIndiana': -5,
    'US/Hawaii': -10,
    'US/IndianaStarke': -6,
    'US/Michigan': -5,
    'US/Mountain': -7,
    'US/Pacific': -8,
    'US/PacificNew': -8,
    'US/Samoa': -11,
    UTC: 0,
    WET: 0,
    WSU: 3,
    Zulu: 0,
};

module.exports = timezones;
